<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteLotConfirm(form)" :vm-action="false" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalImagesVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          uploader(
            v-model="fileList"
            :url="`/api/lot-image/${form.id}`"
            title="Upload Images"
            limit="1"
            @on-change="onChange"
            @on-success="onSuccess"
            )
</template>

<script>
import Uploader from 'vux-uploader-component'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Lots')

export default {
  name: 'ModalLots',
  components: {
    Uploader
  },
  data () {
    return {
      fileList: []
    }
  },
  props: {
    form: {
      type: Object
    },
    title: {
      default: 'Agregar Imagenes',
      type: String
    }
  },
  validations: {
    form: {
    }
  },
  computed: {
    ...mapGetters([
      'isModalImagesVisible',
      'lotsCatalog',
      'pagination'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('lots.add') : this.$t('lots.edit')
    }
  },
  methods: {
    ...mapActions([
      'addLot',
      'editLot',
      'deleteLotImage',
      'setModalImagesVisible',
      'loadCatalog',
      'loadLots'
    ]),
    async onChange (fileItem, fileList) {
      if (fileItem && fileItem.id) {
        await this.deleteLotImage(fileItem)
        await this.loadLots({ page: this.pagination.currentPage })
      }
    },
    async onSuccess (res, fileItem) {
      await setTimeout(() => {
        this.fileList.length > 0 && this.fileList.pop()
        this.fileList.push(res)
      }, 700)
      await this.loadLots({ page: this.pagination.currentPage })
    },
    async deleteLotConfirm (lot) {
      let t = this
      this.auxDeleteLot = () => {
        t.deleteLot(lot)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(lot.id) }),
        accept: this.auxDeleteLot
      })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalImagesVisible(false)
    }
  },
  watch: {
    isModalImagesVisible (visible) {
      if (visible === true) {
        setTimeout(() => {
          this.fileList = [...this.form.images]
        }, 700)
      }
    }
  }
}
</script>

<style lang="css" scoped>

</style>
